export default "__VITE_ASSET__9190287d__"